import service from '@/utils/request'
import { requestService as encryptionService } from '@/utils/axios-encryption'

const baseURL = process.env.VUE_APP_TP_URL || process.env.VUE_APP_URL;

const getPlanTripNumber = (payload, cancelToken) => {
	return encryptionService({
		baseURL: baseURL,
		url: '/tp/places/number/v2',
		method: 'post',
		data: { id: payload.id },
		cancelToken
	});
}

const getStaticData = (payload, cancelToken) => {
	return encryptionService({
		baseURL: baseURL,
		url: '/tp/place/service/v2',
		method: 'post',
		data: { id: payload.id },
		cancelToken
	});
}
/**
 * @description 获取当前点的 历史状态信息列表 （入口: view history按钮）
 * @param {Object} payload 
 */
const getPlanTripHistory = (payload, cancelToken) => {
	let data = { id: payload.id }
	if(payload.limit){
		data.limit = payload.limit;
		if(payload.before){
			data.before = payload.before
		}
	}
	return encryptionService({
		baseURL: baseURL,
		url: '/tp/places/history/v2',
		method: 'post',
		data,
		cancelToken
	});
}
/**
 * @description 获取油价信息
 * @param {Object} payload 
 */
const getPlanTripFuel = (payload, cancelToken) => {
	return encryptionService({
		baseURL: baseURL,
		url: '/tp/places/fuel_prices/new/v2',
		method: 'post',
		data: payload,
		cancelToken
	});
}
/**
 * @description 获取poi用户评论信息
 * @param {Object} payload 
 */
const getPlanTripReview = (payload, cancelToken) => {
	let data = {
		limit: payload.limitReviews,
		sort: payload.sort,
		before: payload.before,
		id: payload.id
	}
	if(typeof payload.page !== 'undefined'){
		data.page = payload.page
	}
	return encryptionService({
		baseURL: baseURL,
		url: '/tp/places/reviews/v3',
		method: 'post',
		data,
		cancelToken
	});
}

/**
 * @description 获取facility用户评论信息
 * @param {Object} payload 
 */
 const getFacilityReview = payload => {
	let data = {
		limit: payload.limitReviews,
		sort: payload.sort,
		page: payload.page || 1,
		id: payload.id
	}
	return encryptionService({
		baseURL: baseURL,
		url: '/tp/facility/reviews/v2',
		method: 'post',
		data
	});
}

/**
 * @description 获取附近餐厅列表接口
 * @param {Object} payload 
 */
const getPlanTripRest = (payload, cancelToken) => {
	let data = {
		radius: '40000',
		latitude: payload.latitude,
		longitude: payload.longitude,
		limit: payload.limitRest
	}
	if(payload.page){
		data.offset = payload.page * payload.limitRest
	}
	return service({
		baseURL: baseURL,
		url: `/tp/businesses/search`,
		method: 'post',
		responseType: 'json',
		data: data,
		cancelToken
	});
}
/**
 * @description 获取dock类型点的 信息
 * @param {Object} payload 
 */
const getPlanDockStatus = payload => {
	let data = { id: payload.id }
	if(payload.limit){
		data.limit = payload.limit;
		if(data.before){
			data.before = payload.before
		}
	}
	if (payload.id) {
		return encryptionService({
			baseURL: baseURL,
			url: '/tp/loadingdock/history/v2',
			method: 'post',
			data
		});
	}
}
// /**
//  * @description 获取当前poi点的 预测信息 （入口: parking insight按钮）
//  * @param {Object} payload（参数id） 
//  */
// const getParkingPrediction = payload =>{
// 	if (payload.id) {
// 		return service({
// 			baseURL: baseURL,
// 			url: `/tp/places/${payload.id}/prediction/info`,
// 			method: 'get',
// 			responseType: 'json',
// 		});
// 	}
// }

const getPoiFence = (poiId, cancelToken) => {
  return encryptionService({
		baseURL: baseURL,
		url: '/tp/place/fence/v2',
		method: 'post',
		data: { id: poiId },
		cancelToken
  })
}
export default {
	getPlanTripNumber,
	getStaticData,
	getPlanTripHistory,
	getPlanTripFuel,
	getPlanTripReview,
	getFacilityReview,
	getPlanTripRest,
	getPlanDockStatus,
	// getParkingPrediction,
	getPoiFence
}
